
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Router from 'vue-router'
import animated from 'animate.css' 
import axios from 'axios';
import $ from 'jquery'
import 'amfe-flexible/index.js'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    'inline': false, // 启用 inline 模式
    'button': true, // 显示右上角关闭按钮
    'navbar': false, // 显示缩略图导航
    'title': false, // 显示当前图片的标题
    'toolbar': false, // 显示工具栏
    'tooltip': false, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    'rotatable': false, // 图片是否可旋转
    'scalable': false, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    'fullscreen': false, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
})

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

import {
  Button,
  Overlay
} from 'vant'

// 按需引入UI组件
Vue.use(Button)
Vue.use(Overlay)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(animated)
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js